<template lang="pug">
  .general-view
    .container(v-if="!loading")
      vm-row(vm-w=12)
        vm-col(vm-type="flex" vm-align="center" vm-lg=1 vm-sm=1)
          a(href="javascript:history.go(-1)")
            vm-button(icon="arrow-back-outline" radius)
        vm-col(vm-w=5)
          .title
            h1 {{ project.project_name }}
            h4.location - {{ project.location }}
            span.badge {{ project.currency_display }}
          span.created_at Created on: {{ createdAt }} - Last updated on: {{ updatedAt }}
        vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=6)
          vm-button.print(v-if="$auth.check('Admin')" type="flat" icon="printer-outline" color="grey" @click="printReport(project.id)") General Report
      horizontal-time-line.center-timeline(:nodes="etapas" :stage="project.stage" :selected="selectedStage" :rfi="project.rfis" :quotations="project.quotation" :progress="calculateProgress" @selected="setSelectedStage")
      .cards-container
        .card(v-for="(column, index) in columns")
          span.c-title {{ $t(`projects.${column}`) }}
          span.c-body(v-if="column != 'amount' && column != 'project_created_by' && column != 'status' && column != 'quotation_created_by' && column != 'date_of_delivery'") {{ parseText(project[column]) || '-' }}
          span.c-body(v-if="column == 'amount'") {{ project[column] | currency }}
          span.c-body(v-if="column == 'project_created_by'") {{ project['project_created']['name'] }}
          span.c-body(v-if="column == 'quotation_created_by'") {{ project['quotation_created']['name'] }}
          span.c-body(v-if="column == 'date_of_delivery'") {{ parseText(project['upload_quotation_date']) || '-' }}
          span.c-body(v-if="column == 'status'") {{ project['status_display'] }}
      .cards-container.center-cards
        .card(v-for="(column, index) in columnsInvoices")
          span.c-title {{ $t(`projects.${column}`) }}
          span.c-body.invoiced-color(v-if="column == 'total_invoiced'") {{ project['amount_paid_invoice'] | currency }}
          span.c-body.payments-color(v-if="column == 'total_payments'") {{ project['amount_paid'] | currency }}
          span.c-body.pending-color(v-if="column == 'total_pending'") {{ project['amount_due'] | currency }}
          span.c-body.payments-color(v-if="column == 'additive'") {{ project['additives'] | currency }}
          span.c-body.pending-color(v-if="column == 'deductive'") {{ project['deductives'] | currency }}
      vm-row.container__details(vm-w=12)
        vm-col.col.padding-right(vm-w=6 v-if="selectedStage > 2")
          h2 Fabricated
          vm-col.col(vm-w=12)
            expanded-scope-general.expanded(v-for="(item, index) in details" :category="item")
        vm-col.col.padding-left(vm-w=6 v-if="selectedStage > 2")
          vm-table(max-height="350px" :data="shipments")
            template(slot="header")
              h2 Shipped
            template(slot="thead")
              vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columnsShipped") {{ $t('projects.' + column) }}
            template(slot-scope="{data}")
              vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columnsShipped")
                  slot(v-if="column != 'status'") {{data[indextr][column]}}
                vm-td
                vm-button(type="flat" icon="eye-outline" color="#afbbc6" @click="$router.push(`/in-orders/${project.id}/shipments`)")
    .loader-cont(v-else)
      loader
    ul.circles
      li
      li
      li
      li
      li
      li
      li
      li
      li
      li
</template>

<script>
import moment from 'moment'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Projects')

export default {
  name: 'ProjectsGeneralDetail',
  components: {
    Loader: () => import('@/components/aditionals/Loader.vue'),
    HorizontalTimeLine: () =>
      import('@/components/aditionals/HorizontalTimeLine.vue'),
    ExpandedScopeGeneral: () => import('@/components/in-order/ExpandedScopeGeneral.vue')
  },
  data: () => ({
    loading: false,
    selected: [],
    selectedStage: 3,
    etapas: [
      {
        name: 'To Quote',
        url: '',
        icon: 'layers-outline'
      },
      {
        name: 'Quoted',
        url: '',
        icon: 'inbox-outline'
      },
      {
        name: 'In Order',
        url: '/in-orders/',
        icon: 'cube-outline'
      },
      {
        name: 'Finished',
        url: '/finished/',
        icon: 'done-all-outline'
      }
    ],
    columns: [],
    columnsToQuote: ['project_created_on', 'quotation_delivery_date', 'docs_date_recived', 'project_created_by'],
    columnsQuoted: ['amount', 'status', 'quotation_start_date', 'quotation_delivery_date', 'date_of_delivery', 'quotation_created_by'],
    columnsInOrder: ['amount', 'previous_delivery_deadline', 'delivery_deadline', 'assigned_date'],
    columnsFinished: ['amount', 'project_created_on', 'quotation_start_date', 'delivery_deadline', 'completion_date'],
    columnsShipped: ['remission_number', 'addressee', 'shipped_date', 'comments'],
    columnsInvoices: ['total_invoiced', 'total_payments', 'total_pending', 'additive', 'deductive']
  }),
  async created () {
    this.$route.params.id && (await this.getProject())
  },
  methods: {
    ...mapActions([
      'loadProject',
      'loadDetails',
      'loadShipments',
      'printReport'
    ]),
    async getProject (page) {
      this.loading = true
      await this.loadProject(this.$route.params).then(() => {
        this.setSelectedStage(this.project.stage)
        this.loadDetails(this.$route.params)
        this.loadShipments(this.$route.params)
      })
      this.loading = false
    },
    parseText (str) {
      if (/^(19|20)\d\d[- /.](0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])$/.test(str)) {
        return moment(str).format('ll')
      } else {
        return str
      }
    },
    setSelectedStage (stage) {
      this.selectedStage = stage
      switch (stage) {
        case 1:
          this.columns = this.columnsToQuote
          break
        case 2:
          this.columns = this.columnsQuoted
          break
        case 3:
          this.columns = this.columnsInOrder
          break
        case 4:
          this.columns = this.columnsFinished
          break
        default:
          this.columns = this.columnsToQuote
          break
      }
    }
  },
  computed: {
    ...mapGetters([
      'project',
      'details',
      'shipments'
    ]),
    createdAt () {
      return moment(this.project.created_at).format('ll')
    },
    updatedAt () {
      return moment(this.project.updated_at).format('ll')
    },
    calculateProgress () {
      if (this.project.stage <= 1) return (0 / 6) * 100
      if (this.project.stage === 2) return (2 / 6) * 100
      if (this.project.stage === 3) return (4 / 6) * 100
      if (this.project.stage === 4) return (6 / 6) * 100
    }
  },
  watch: {
    project (project) {
      this.setSelectedStage(project.stage)
      this.loadDetails(this.$route.params)
      this.loadShipments(this.$route.params)
    }
  }
}
</script>

<style lang="scss" scoped>
.general-view {
  height: 100%;
  width: 100%;
  z-index: 998;
}
.container {
  width: 100%;
  padding: 40px 40px;
  overflow: scroll;
  height: auto;
  z-index: 99999;
}
.container__details {
  z-index: 3;
  position: relative;
}
.loader-cont {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 998;
}
.created_at {
  color: gray;
}
.title {
  display: flex;
  align-items: center;
}
.print {
  z-index: 99;
}
.badge {
  background: rgb(237, 28, 36);
  border-radius: 20px;
  padding: 5px 15px;
  color: white;
  margin: 0 25px;
}

.location {
  color: gray;
  margin-left: 10px;
}

.center-timeline {
  max-width: 800px;
  margin: 40px auto;
}

.cards-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0 20px 0;
}
.center-cards {
  justify-content: center;
}

.card {
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 25%;
  height: 100px;
  border-radius: 10px;
  -webkit-box-shadow: 0px 4px 9px -5px rgba(0,0,0,0.15);
  -moz-box-shadow: 0px 4px 9px -5px rgba(0,0,0,0.15);
  box-shadow: 0px 4px 9px -5px rgba(0,0,0,0.15);
  margin: 0 10px;
  z-index: 1;
}

.c-body {
  font-weight: bold;
  font-size: 2rem;
  line-height: 2rem;
}

.circles {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 0;
  visibility: inherit;
}

.circles li {
  position: absolute;
  display: block;
  list-style: none;
  width: 20px;
  height: 20px;
  background: linear-gradient(
    45deg,
    rgba(237, 28, 36, 0.1),
    rgba(237, 28, 36, 0.3)
  );
  z-index: 0;
  animation: animate 25s linear infinite;
  bottom: -150px;
}

.circles li:nth-child(1) {
  left: 25%;
  width: 80px;
  height: 80px;
  animation-delay: 0s;
}

.circles li:nth-child(2) {
  left: 10%;
  width: 20px;
  height: 20px;
  animation-delay: 2s;
  animation-duration: 12s;
}

.circles li:nth-child(3) {
  left: 70%;
  width: 20px;
  height: 20px;
  animation-delay: 4s;
}

.circles li:nth-child(4) {
  left: 40%;
  width: 60px;
  height: 60px;
  animation-delay: 0s;
  animation-duration: 18s;
}

.circles li:nth-child(5) {
  left: 65%;
  width: 20px;
  height: 20px;
  animation-delay: 0s;
}

.circles li:nth-child(6) {
  left: 75%;
  width: 110px;
  height: 110px;
  animation-delay: 3s;
}

.circles li:nth-child(7) {
  left: 35%;
  width: 150px;
  height: 150px;
  animation-delay: 7s;
}

.circles li:nth-child(8) {
  left: 50%;
  width: 25px;
  height: 25px;
  animation-delay: 15s;
  animation-duration: 45s;
}

.circles li:nth-child(9) {
  left: 20%;
  width: 15px;
  height: 15px;
  animation-delay: 2s;
  animation-duration: 35s;
}

.circles li:nth-child(10) {
  left: 85%;
  width: 150px;
  height: 150px;
  animation-delay: 0s;
  animation-duration: 11s;
}

@keyframes animate {
  0% {
    transform: translateY(0) rotate(0deg);
    opacity: 1;
    border-radius: 0;
  }

  100% {
    transform: translateY(-1000px) rotate(720deg);
    opacity: 0;
    border-radius: 50%;
  }
}
.invoiced-color {
  color: rgb(68, 152, 224);
}
.payments-color {
  color: rgb(61, 203, 111);
}
.pending-color {
  color: rgb(237, 27, 36);
}
.padding-right {
  padding-right: 10px;
}
.padding-left {
  padding-left: 10px;
}
</style>
